import { t } from "../../../i18n";
import { RouteComponentProps } from "react-router";
import GenericTextButton from "../../../layout/GenericTextButton";
import { PATH } from "../UserModalController";
import { setModalPath } from "../utils";

type Option = {
  locales: string;
  beforeAndAfterLocales?: string[];
  type: PATH | any | string
};
interface Props extends Partial<RouteComponentProps> {
  options: Option[];
};

const ModalNavigation = ({ options, history }: Props): JSX.Element => {
  const setPath = (type: PATH) => {
    if(history){
      setModalPath({path: {type: type, modal: PATH.MODAL_TYPE}, history})
    }
  }

  return options.map((opt, idx) => {
    return <GenericTextButton classname={`${opt.type === PATH.REGISTRATION && "register-link"}`} style={{padding: "0 10px"}} key={idx} onClick={() => setPath(opt.type)} beforeAndAfterLocales={opt.beforeAndAfterLocales} title={t(opt.locales)}/>
  }) as unknown as JSX.Element;
};

export default ModalNavigation;
